module.exports = __webpack_public_path__ + "img/ch09_18_布洛夜谈.079b4938.jpg";